import './NavbarItem.css';
import NavbarContent from "./sub/NavbarContent/NavbarContent.jsx";
import { Link } from "react-router-dom";

export default function NavbarItem({item}) {
    return (
        <Link className="navbar-item-container" to={item.link}>
            <div className="navbar-item-inner">
                <div className="navbar-item-image-container">
                    <img src={item.image} alt={`${item.name} icon`} className='navbar-item-image'/>
                </div>
                <div className='navbar-item-name'>
                    {item.name}
                </div>
            </div>
            {item.sub.length > 0 && <NavbarContent content={item.sub}/>}
        </Link>
    );
}